<template>
  <div class="setup-account" :class="{ 'remove-height': $store.getters.ISTRIAL || is_subscription_active }">
    <top-header></top-header>
    <div class="pb-1" style="height:80px;">
      <div class="container-fluid d-flex justify-content-center">
        <div class="row">
          <div class="col">
            <h5 class="mt-4">
              Payments & Billing
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div class="form">
      <template v-if="$store.getters.ISTRIAL">
        <template v-if="account_type === 1">
          <template v-if="!completed">
            <div class="row package">
              <div class="col-7">
                <h5 class="text-center my-3 mb-3">Packages</h5>
                <div class="row">
                  <div class="col" v-for="(pack, index) in packages" :key="index">
                    <div class="card" :class="{ 'selected-plan': selected === pack.name }">
                      <div class="card-body">
                        <h4 style="text-transform: capitalize">{{ showPackName(pack.name) }}</h4>
                        <h5 class="single-title">File Management</h5>
                        <ul>
                          <li class="d-flex mb-2 align-content-center" v-for="(file, i) in pack.features.file_management"
                            :key="i">
                            <span>
                              <svg style="width:14px;height:14px" viewBox="0 0 24 24">
                                <path fill="#68f485"
                                  d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" />
                              </svg>
                            </span>
                            <span class="small-text" style="margin-top:.15em" v-html="file"></span>
                          </li>
                        </ul>
                        <template v-if="pack.view">
                          <h5 class="single-title">Collaboration Tools</h5>
                          <ul>
                            <li class="d-flex mb-2 align-content-center"
                              v-for="(tools, i) in pack.features.collaboration_tools" :key="i">
                              <span>
                                <svg style="width:14px;height:14px" viewBox="0 0 24 24">
                                  <path fill="#68f485"
                                    d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" />
                                </svg>
                              </span>
                              <span class="small-text" style="margin-top:.15em" v-html="tools"></span>
                            </li>
                          </ul>
                          <h5 class="single-title">Security and Management</h5>
                          <ul>
                            <li class="d-flex mb-2 align-content-center"
                              v-for="(security, i) in pack.features.security_and_management" :key="i">
                              <span>
                                <svg style="width:14px;height:14px" viewBox="0 0 24 24">
                                  <path fill="#68f485"
                                    d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" />
                                </svg>
                              </span>
                              <span class="small-text" style="margin-top:.15em" v-html="security"></span>
                            </li>
                          </ul>
                          <span style="cursor:pointer;font-size:14px;font-weight:bold" class="ml-3 mb-3 mt-3 d-block"
                            @click="viewmore(index)">View less...</span>
                        </template>
                        <template v-if="!pack.view">
                          <span style="cursor:pointer;font-size:14px;font-weight:bold" class="ml-3 mb-3 d-block"
                            @click="viewmore(index)">View More...</span>
                        </template>
                        <ul>
                          <li>
                            <span class="btn" @click="select_plan(pack.name)">
                              <svg style="width:24px;height:24px" viewBox="0 0 24 24" v-if="selected == pack.name">
                                <path fill="currentColor"
                                  d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                              </svg>
                              Choose
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <h5 class="text-center my-3">Users</h5>
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col">
                        <h4>
                          {{ chosen_plan }}
                        </h4>
                        <p class="my-3">
                          <strong>Your billing cycle</strong>
                        </p>
                        <p v-if="chosen_plan !== 'Personal Pro'">
                          Total Users <input type="number" class="ml-2 p-2 rounded border" @input="user_choosen"
                            v-model="total_users" :min="min_total_users" :max="max_total_users" />
                        </p>
                        <ul class="d-flex row">
                          <li class="col">
                            <label class="d-flex flex-column">
                              <span class="mb-1">
                                Billed yearly
                              </span>
                              <span>
                                <input type="radio" @click="amt_choosen" v-model="plan" value="yearly" />
                                <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                                  v-if="country == 'usa'">&#36;</span>{{ Number(yearly).toLocaleString() }} / year
                              </span>
                            </label>
                          </li>
                          <li class="col">
                            <label class="d-flex flex-column">
                              <span class="mb-1">
                                Billed monthly
                              </span>
                              <span>
                                <input type="radio" @click="amt_choosen" v-model="plan" value="monthly" />
                                <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                                  v-if="country == 'usa'">&#36;</span>{{ Number(monthly).toLocaleString() }} / month
                              </span>
                            </label>
                          </li>
                        </ul>
                        <p>Total Cost: <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                            v-if="country == 'usa'">&#36;</span>{{ total_amount.toLocaleString() }}</p>
                        <p>Total Users: {{ total_users }}</p>
                        <p class="mt-2">
                          <template v-if="country == 'usa'">
                            <span class="btn" @click="stripePay">
                              Make Payment
                            </span>
                          </template>
                          <template v-else>
                            <span class="btn" @click="makePayment">
                              Make Payment
                            </span>
                          </template>
                        </p>
                        <p class="mt-2">
                          <img src="@/assets/visa.png" />
                          <img class="ml-2" src="@/assets/mastercard.png" />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-if="completed">
            <div class="card shadow-sm p-3 mb-5 bg-white rounded listed-department col-md-4">
              <div class="card-body">
                <h4>
                  {{ current_plan }}
                </h4>
                <p class="my-3">
                  <strong>Status: </strong> Active
                </p>
                <p>
                  No outstanding billing
                </p>
              </div>
            </div>
          </template>
        </template>
        <template v-if="account_type === 2">
          <template v-if="!completed">
            <template v-if="current_plan === 'Business Plus'">
              <div class="row package d-flex justify-content-center" style="margin: 3em 0">
                <div class="col-md-4 col-sm-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col">
                          <h5>Current Plan: {{ current_plan }}</h5>
                          <h6>Current Plan Billing</h6>
                          <p class="my-2">
                            Total Users <input type="number" class="ml-2 p-2 rounded border" @change="user_choosen"
                              v-model="total_users" :min="min_total_users" />
                          </p>
                          <ul class="d-flex row my-3">
                            <li class="col">
                              <label class="d-flex flex-column">
                                <span class="mb-1">
                                  Billed yearly
                                </span>
                                <span>
                                  <input type="radio" @click="amt_choosen" v-model="plan" value="yearly" />
                                  <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                                    v-if="country == 'usa'">&#36;</span>{{ yearly.toLocaleString() }} / year
                                </span>
                              </label>
                            </li>
                            <li class="col">
                              <label class="d-flex flex-column">
                                <span class="mb-1">
                                  Billed monthly
                                </span>
                                <span>
                                  <input type="radio" @click="amt_choosen" v-model="plan" value="monthly" />
                                  <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                                    v-if="country == 'usa'">&#36;</span>{{ Number(monthly).toLocaleString() }} / month
                                </span>
                              </label>
                            </li>
                          </ul>
                          <p class="my-2">Total Cost: <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span
                              class="ml-2" v-if="country == 'usa'">&#36;</span>{{ total_amount.toLocaleString() }}</p>
                          <p class="my-2">Total Users: {{ total_users }}</p>
                          <p class="mt-2">
                            <template v-if="country == 'usa'">
                              <span class="btn" @click="stripePay">
                                Make Payment
                              </span>
                            </template>
                            <template v-else>
                              <span class="btn" @click="makePayment">
                                Make Payment
                              </span>
                            </template>
                          </p>
                          <p class="mt-2">
                            <img src="@/assets/visa.png" />
                            <img class="ml-2" src="@/assets/mastercard.png" />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="current_plan === 'Business'">
              <div class="row package">
                <div class="col-7">
                  <h5 class="text-center my-3 mb-3">Packages</h5>
                  <div class="row">
                    <div class="col" v-for="(pack, index) in packages" :key="index">
                      <div class="card" :class="{ 'selected-plan': selected === pack.name }">
                        <div class="card-body">
                          <h4 style="text-transform: capitalize">{{ showPackName(pack.name) }}</h4>
                          <h5 class="single-title">File Management</h5>
                          <ul>
                            <li class="d-flex mb-2 align-content-center"
                              v-for="(file, i) in pack.features.file_management" :key="i">
                              <span>
                                <svg style="width:14px;height:14px" viewBox="0 0 24 24">
                                  <path fill="#68f485"
                                    d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" />
                                </svg>
                              </span>
                              <span class="small-text" style="margin-top:.15em" v-html="file"></span>
                            </li>
                          </ul>
                          <template v-if="pack.view">
                            <h5 class="single-title">Collaboration Tools</h5>
                            <ul>
                              <li class="d-flex mb-2 align-content-center"
                                v-for="(tools, i) in pack.features.collaboration_tools" :key="i">
                                <span>
                                  <svg style="width:14px;height:14px" viewBox="0 0 24 24">
                                    <path fill="#68f485"
                                      d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" />
                                  </svg>
                                </span>
                                <span class="small-text" style="margin-top:.15em" v-html="tools"></span>
                              </li>
                            </ul>
                            <h5 class="single-title">Security and Management</h5>
                            <ul>
                              <li class="d-flex mb-2 align-content-center"
                                v-for="(security, i) in pack.features.security_and_management" :key="i">
                                <span>
                                  <svg style="width:14px;height:14px" viewBox="0 0 24 24">
                                    <path fill="#68f485"
                                      d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" />
                                  </svg>
                                </span>
                                <span class="small-text" style="margin-top:.15em" v-html="security"></span>
                              </li>
                            </ul>
                            <span style="cursor:pointer;font-size:14px;font-weight:bold" class="ml-3 mb-3 mt-3 d-block"
                              @click="viewmore(index)">View less...</span>
                          </template>
                          <template v-if="!pack.view">
                            <span style="cursor:pointer;font-size:14px;font-weight:bold" class="ml-3 mb-3 d-block"
                              @click="viewmore(index)">View More...</span>
                          </template>
                          <ul>
                            <li>
                              <span class="btn" @click="select_plan(pack.name)">
                                <svg style="width:24px;height:24px" viewBox="0 0 24 24" v-if="selected == pack.name">
                                  <path fill="currentColor"
                                    d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                                </svg>
                                Choose
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-5">
                  <h5 class="text-center my-3">Users</h5>
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col">
                          <h5>Current Plan: {{ current_plan }}</h5>
                          <h6>Current Plan Billing</h6>
                          <p>
                            Total Users <input type="number" class="ml-2 p-2 rounded border" @input="user_choosen"
                              v-model="total_users" :min="min_total_users" :max="max_total_users" />
                          </p>
                          <ul class="d-flex row">
                            <li class="col">
                              <label class="d-flex flex-column">
                                <span class="mb-1">
                                  Billed yearly
                                </span>
                                <span>
                                  <input type="radio" @click="amt_choosen" v-model="plan" value="yearly" />
                                  <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                                    v-if="country == 'usa'">&#36;</span>{{ yearly.toLocaleString() }} / year
                                </span>
                              </label>
                            </li>
                            <li class="col">
                              <label class="d-flex flex-column">
                                <span class="mb-1">
                                  Billed monthly
                                </span>
                                <span>
                                  <input type="radio" @click="amt_choosen" v-model="plan" value="monthly" />
                                  <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                                    v-if="country == 'usa'">&#36;</span>{{ Number(monthly).toLocaleString() }} / month
                                </span>
                              </label>
                            </li>
                          </ul>
                          <p>Total Cost: <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                              v-if="country == 'usa'">&#36;</span>{{ total_amount.toLocaleString() }}</p>
                          <p>Total Users: {{ total_users }}</p>
                          <p class="mt-2">
                            <template v-if="country == 'usa'">
                              <span class="btn" @click="stripePay">
                                Make Payment
                              </span>
                            </template>
                            <template v-else>
                              <span class="btn" @click="makePayment">
                                Make Payment
                              </span>
                            </template>
                          </p>
                          <p class="mt-2">
                            <img src="@/assets/visa.png" />
                            <img class="ml-2" src="@/assets/mastercard.png" />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
          <template v-if="completed">
            <div class="card shadow-sm p-3 mb-5 bg-white rounded listed-department col-md-4">
              <div class="card-body">
                <h4>
                  {{ current_plan }}
                </h4>
                <p class="my-3">
                  <strong>Status: </strong> Active
                </p>
                <p>
                  No outstanding billing
                </p>
                <hr />
                <p>Available Balance: <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                    v-if="country == 'usa'">&#36;</span>{{ Number(balance).toLocaleString() }}</p>
                <p>Current Total User: {{ company_total_users }}</p>
                <p class="mt-3">
                  <span class="btn btn-primary" @click="more_users">Buy More Users</span>
                </p>
              </div>
            </div>
          </template>
        </template>
      </template>
      <template v-if="!$store.getters.ISTRIAL">
        <template v-if="account_type === 1">
          <template v-if="is_subscription_active">
            <div class="card shadow-sm p-3 mb-5 bg-white rounded listed-department col-md-4">
              <div class="card-body">
                <h4>
                  {{ current_plan }}
                </h4>
                <p class="my-3">
                  <strong>Status: </strong> Active
                </p>
                <p style="font-size:12px">
                  <strong>Expires on:</strong> {{ expiration() }} ( {{ daysLeft() }} )
                </p>
                <p>
                  No outstanding billing
                </p>
              </div>
            </div>
          </template>
          <template v-if="!is_subscription_active">
            <template v-if="!completed">
              <div class="row package">
                <div class="col-7">
                  <h5 class="text-center my-3 mb-3">Packages</h5>
                  <div class="row">
                    <div class="col" v-for="(pack, index) in packages" :key="index">
                      <div class="card" :class="{ 'selected-plan': selected === pack.name }">
                        <div class="card-body">
                          <h4 style="text-transform: capitalize">{{ showPackName(pack.name) }}</h4>
                          <h5 class="single-title">File Management</h5>
                          <ul>
                            <li class="d-flex mb-2 align-content-center"
                              v-for="(file, i) in pack.features.file_management" :key="i">
                              <span>
                                <svg style="width:14px;height:14px" viewBox="0 0 24 24">
                                  <path fill="#68f485"
                                    d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" />
                                </svg>
                              </span>
                              <span class="small-text" style="margin-top:.15em" v-html="file"></span>
                            </li>
                          </ul>
                          <template v-if="pack.view">
                            <h5 class="single-title">Collaboration Tools</h5>
                            <ul>
                              <li class="d-flex mb-2 align-content-center"
                                v-for="(tools, i) in pack.features.collaboration_tools" :key="i">
                                <span>
                                  <svg style="width:14px;height:14px" viewBox="0 0 24 24">
                                    <path fill="#68f485"
                                      d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" />
                                  </svg>
                                </span>
                                <span class="small-text" style="margin-top:.15em" v-html="tools"></span>
                              </li>
                            </ul>
                            <h5 class="single-title">Security and Management</h5>
                            <ul>
                              <li class="d-flex mb-2 align-content-center"
                                v-for="(security, i) in pack.features.security_and_management" :key="i">
                                <span>
                                  <svg style="width:14px;height:14px" viewBox="0 0 24 24">
                                    <path fill="#68f485"
                                      d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" />
                                  </svg>
                                </span>
                                <span class="small-text" style="margin-top:.15em" v-html="security"></span>
                              </li>
                            </ul>
                            <span style="cursor:pointer;font-size:14px;font-weight:bold" class="ml-3 mb-3 mt-3 d-block"
                              @click="viewmore(index)">View less...</span>
                          </template>
                          <template v-if="!pack.view">
                            <span style="cursor:pointer;font-size:14px;font-weight:bold" class="ml-3 mb-3 d-block"
                              @click="viewmore(index)">View More...</span>
                          </template>
                          <ul>
                            <li>
                              <span class="btn" @click="select_plan(pack.name)">
                                <svg style="width:24px;height:24px" viewBox="0 0 24 24" v-if="selected == pack.name">
                                  <path fill="currentColor"
                                    d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                                </svg>
                                Choose
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-5">
                  <h5 class="text-center my-3">Users</h5>
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col">
                          <h4 style="color:#0f4670">
                            {{ chosen_plan }}
                          </h4>
                          <p class="my-3">
                            <strong>Your billing cycle</strong>
                          </p>
                          <p v-if="chosen_plan !== 'Personal Pro'">
                            Number of Users <input type="number" class="ml-2 p-2 rounded border" @input="user_choosen"
                              v-model="total_users" :min="min_total_users" :max="max_total_users" />
                          </p>
                          <ul class="d-flex row">
                            <li class="col">
                              <label class="d-flex flex-column">
                                <span class="mb-1">
                                  Billed yearly
                                </span>
                                <span>
                                  <input type="radio" @click="amt_choosen" v-model="plan" value="yearly" />
                                  <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                                    v-if="country == 'usa'">&#36;</span>{{ Number(yearly).toLocaleString() }} / year
                                </span>
                              </label>
                            </li>
                            <li class="col">
                              <label class="d-flex flex-column">
                                <span class="mb-1">
                                  Billed monthly
                                </span>
                                <span>
                                  <input type="radio" @click="amt_choosen" v-model="plan" value="monthly" />
                                  <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                                    v-if="country == 'usa'">&#36;</span>{{ Number(monthly).toLocaleString() }} / month
                                </span>
                              </label>
                            </li>
                          </ul>
                          <p>Total Amount: <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                              v-if="country == 'usa'">&#36;</span>{{ total_amount.toLocaleString() }}</p>
                          <p>Total Users: {{ total_users }}</p>
                          <p class="mt-2">
                            <template v-if="country == 'usa'">
                              <span class="btn" @click="stripePay">
                                Make Payment
                              </span>
                            </template>
                            <template v-else>
                              <span class="btn" @click="makePayment">
                                Make Payment
                              </span>
                            </template>
                          </p>
                          <p class="mt-2">
                            <img src="@/assets/visa.png" />
                            <img class="ml-2" src="@/assets/mastercard.png" />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="completed">
              <div class="card shadow-sm p-3 mb-5 bg-white rounded listed-department col-md-4">
                <div class="card-body">
                  <h4>
                    {{ current_plan }}
                  </h4>
                  <p class="my-3">
                    <strong>Status: </strong> Active
                  </p>
                  <p>
                    No outstanding billing
                  </p>
                </div>
              </div>
            </template>
          </template>
        </template>
        <template v-if="account_type === 2">
          <template v-if="is_subscription_active">
            <template v-if="!add_more_users">
              <div class="card shadow-sm p-3 mb-5 bg-white rounded listed-department col-md-4">
                <div class="card-body">
                  <h4 style="color:#0f4670">
                    {{ current_plan }}
                  </h4>
                  <p>
                    <strong>Status: </strong> Active
                  </p>
                  <p class="mb-3" style="font-size: 12px;">
                    <strong>Expires on:</strong> {{ expiration() }} ( {{ daysLeft() }} )
                  </p>
                  <p>
                    No outstanding billing
                  </p>
                  <hr />
                  <p>Credit Balance: <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                      v-if="country == 'usa'">&#36;</span>{{ Number(balance).toLocaleString() }}</p>
                  <p>Current User: {{ company_total_users }}</p>
                  <p class="mt-3">
                    <span class="btn btn-primary" @click="more_users">Buy More Users</span>
                  </p>
                </div>
              </div>
            </template>
            <template v-if="add_more_users">
              <template v-if="!completed">
                <div class="row w-75">
                  <div class="col-md-8">
                    <div class="card w-100 mb-4">
                      <div class="card-body">
                        <div class="row">
                          <div class="col">
                            <h4>Add More Users</h4>
                            <h5>Current Plan: {{ current_plan }}</h5>
                            <h6>Billing Details</h6>
                            <hr />
                            <p>
                              Bal
                              Number of Users <input type="number" class="ml-2 p-2 rounded border" @input="user_choosen"
                                v-model="total_users" :max="max_total_users" />
                            </p>
                            <ul class="d-flex row mt-4">
                              <li class="col" v-if="plan === 'yearly'">
                                <label class="d-flex flex-column">
                                  <span class="mb-1">
                                    Billed yearly
                                  </span>
                                  <span>
                                    <input type="radio" @click="amt_choosen" v-model="plan" value="yearly" />
                                    <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                                      v-if="country == 'usa'">&#36;</span>{{ yearly.toLocaleString() }} / year <span
                                      style="font-size: 12px;">(your current payment was billed at yearly)</span>
                                  </span>
                                </label>
                              </li>
                              <li class="col" v-if="plan === 'monthly'">
                                <label class="d-flex flex-column">
                                  <span class="mb-1">
                                    Billed monthly
                                  </span>
                                  <span>
                                    <input type="radio" @click="amt_choosen" v-model="plan" value="monthly" />
                                    <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                                      v-if="country == 'usa'">&#36;</span>{{ Number(monthly).toLocaleString() }} / month
                                    <span style="font-size: 12px;">(your current payment was billed at monthly)</span>
                                  </span>
                                </label>
                              </li>
                            </ul>
                            <p>Total Amount: <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span
                                class="ml-2" v-if="country == 'usa'">&#36;</span>{{ total_amount.toLocaleString() }}</p>
                            <p>Total Users: {{ total_users }}</p>
                            <p class="mt-2">
                            <div class="row pl-3 w-75">
                              <template v-if="country == 'usa'">
                                <span class="btn btn-block col-md-4" @click="stripePay">
                                  Make Payment
                                </span>
                              </template>
                              <template v-else>
                                <span class="btn btn-block col-md-4" @click="makePayment">
                                  Make Payment
                                </span>
                              </template>
                              <span class="col-md-4 ml-2 btn btn-cancel" @click="more_users">
                                Cancel
                              </span>
                            </div>
                            </p>
                            <p class="mt-2">
                              <img src="@/assets/visa.png" />
                              <img class="ml-2" src="@/assets/mastercard.png" />
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="card w-100">
                      <div class="card-body">
                        <h5>Billing</h5>
                        <p>Credit Balance: <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                            v-if="country == 'usa'">&#36;</span>{{ Math.round(balance, 2).toLocaleString() }}</p>
                        <p>Current Users: {{ company_total_users }} </p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="completed">
                <div class="card shadow-sm p-3 mb-5 bg-white rounded listed-department col-md-4">
                  <div class="card-body">
                    <p>
                      Payment was successful. <br />A confirmation email has been sent to you.
                    </p>
                    <p class="mt-3">
                      <span class="btn btn-primary" @click="more_users">Done</span>
                    </p>
                  </div>
                </div>
              </template>
            </template>
          </template>
          <template v-if="!is_subscription_active">
            <template v-if="!completed">
              <template v-if="current_plan === 'Business Plus'">
                <div class="row w-75 package d-flex justify-content-center" style="margin: 3em 0">
                  <div class="col-8">
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="col">
                            <h5>Current Plan: <strong style="color:#0f4670">{{ current_plan }}</strong></h5>
                            <h6>Current Plan Billing</h6>
                            <p class="my-2">
                              Number of Users <input type="number" class="ml-2 p-2 rounded border" @change="user_choosen"
                                v-model="total_users" :min="min_total_users" />
                            </p>
                            <ul class="d-flex row my-3">
                              <li class="col">
                                <label class="d-flex flex-column">
                                  <span class="mb-1">
                                    Billed yearly
                                  </span>
                                  <span>
                                    <input type="radio" @click="amt_choosen" v-model="plan" value="yearly" />
                                    <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                                      v-if="country == 'usa'">&#36;</span>{{ yearly.toLocaleString() }} / year
                                  </span>
                                </label>
                              </li>
                              <li class="col">
                                <label class="d-flex flex-column">
                                  <span class="mb-1">
                                    Billed monthly
                                  </span>
                                  <span>
                                    <input type="radio" @click="amt_choosen" v-model="plan" value="monthly" />
                                    <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                                      v-if="country == 'usa'">&#36;</span>{{ Number(monthly).toLocaleString() }} / month
                                  </span>
                                </label>
                              </li>
                            </ul>
                            <p class="my-2">Total Amount: <span class="ml-2"
                                v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                                v-if="country == 'usa'">&#36;</span>{{ total_amount.toLocaleString() }}</p>
                            <p>Total Amount Due: <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span
                                class="ml-2" v-if="country == 'usa'">&#36;</span>{{ total_amount > balance ?
                                  Math.round(total_amount - balance, 2).toLocaleString() : Math.round(balance - total_amount,
                                    2).toLocaleString() }}
                              <span class="custom-tooltip-container" style="text-decoration: underline;cursor:pointer;">
                                <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                                  <path fill="currentColor"
                                    d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" />
                                </svg>
                                <span class="custom-tooltiptext" style="left:-60px">If there are available funds in your
                                  credit balance, its total sum will be deducted from your total billing amount.</span>
                              </span>
                            </p>
                            <p class="my-2">Total Users: {{ total_users }}</p>
                            <p class="mt-2">
                              <template v-if="country == 'usa'">
                                <span class="btn" @click="stripePay">
                                  Make Payment
                                </span>
                              </template>
                              <template v-else>
                                <span class="btn" @click="makePayment">
                                  Make Payment
                                </span>
                              </template>
                            </p>
                            <p class="mt-2">
                              <img src="@/assets/visa.png" />
                              <img class="ml-2" src="@/assets/mastercard.png" />
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="card w-100">
                      <div class="card-body">
                        <h5 class="my-3">Billing</h5>
                        <p>Credit Balance: <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                            v-if="country == 'usa'">&#36;</span>{{ Number(balance).toLocaleString() }}</p>
                        <p>Current Users: {{ company_total_users }} </p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="current_plan === 'Business'">
                <div class="row package">
                  <div class="col-6">
                    <h5 class="text-center my-3 mb-3">Packages</h5>
                    <div class="row">
                      <div class="col" v-for="(pack, index) in packages" :key="index">
                        <div class="card" :class="{ 'selected-plan': selected === pack.name }">
                          <div class="card-body">
                            <h4 style="text-transform: capitalize">{{ showPackName(pack.name) }}</h4>
                            <h5 class="single-title">File Management</h5>
                            <ul>
                              <li class="d-flex mb-2 align-content-center"
                                v-for="(file, i) in pack.features.file_management" :key="i">
                                <span>
                                  <svg style="width:14px;height:14px" viewBox="0 0 24 24">
                                    <path fill="#68f485"
                                      d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" />
                                  </svg>
                                </span>
                                <span class="small-text" style="margin-top:.15em" v-html="file"></span>
                              </li>
                            </ul>
                            <template v-if="pack.view">
                              <h5 class="single-title">Collaboration Tools</h5>
                              <ul>
                                <li class="d-flex mb-2 align-content-center"
                                  v-for="(tools, i) in pack.features.collaboration_tools" :key="i">
                                  <span>
                                    <svg style="width:14px;height:14px" viewBox="0 0 24 24">
                                      <path fill="#68f485"
                                        d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" />
                                    </svg>
                                  </span>
                                  <span class="small-text" style="margin-top:.15em" v-html="tools"></span>
                                </li>
                              </ul>
                              <h5 class="single-title">Security and Management</h5>
                              <ul>
                                <li class="d-flex mb-2 align-content-center"
                                  v-for="(security, i) in pack.features.security_and_management" :key="i">
                                  <span>
                                    <svg style="width:14px;height:14px" viewBox="0 0 24 24">
                                      <path fill="#68f485"
                                        d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" />
                                    </svg>
                                  </span>
                                  <span class="small-text" style="margin-top:.15em" v-html="security"></span>
                                </li>
                              </ul>
                              <span style="cursor:pointer;font-size:14px;font-weight:bold" class="ml-3 mb-3 mt-3 d-block"
                                @click="viewmore(index)">View less...</span>
                            </template>
                            <template v-if="!pack.view">
                              <span style="cursor:pointer;font-size:14px;font-weight:bold" class="ml-3 mb-3 d-block"
                                @click="viewmore(index)">View More...</span>
                            </template>
                            <ul>
                              <li>
                                <span class="btn" @click="select_plan(pack.name)">
                                  <svg style="width:24px;height:24px" viewBox="0 0 24 24" v-if="selected == pack.name">
                                    <path fill="currentColor"
                                      d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                                  </svg>
                                  Choose
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <h5 class="text-center my-3">Users</h5>
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="col">
                            <h5>Current Plan: <strong style="color:#0f4670">{{ chosen_plan }}</strong></h5>
                            <h6>Current Plan Billing</h6>
                            <p>
                              Total Users <input type="number" class="ml-2 p-2 rounded border" @input="user_choosen"
                                v-model="total_users" :min="min_total_users" :max="max_total_users" />
                            </p>
                            <ul class="d-flex row">
                              <li class="col">
                                <label class="d-flex flex-column">
                                  <span class="mb-1">
                                    Billed yearly
                                  </span>
                                  <span>
                                    <input type="radio" @click="amt_choosen" v-model="plan" value="yearly" />
                                    <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                                      v-if="country == 'usa'">&#36;</span>{{ yearly.toLocaleString() }} / year
                                  </span>
                                </label>
                              </li>
                              <li class="col">
                                <label class="d-flex flex-column">
                                  <span class="mb-1">
                                    Billed monthly
                                  </span>
                                  <span>
                                    <input type="radio" @click="amt_choosen" v-model="plan" value="monthly" />
                                    <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                                      v-if="country == 'usa'">&#36;</span>{{ Number(monthly).toLocaleString() }} / month
                                  </span>
                                </label>
                              </li>
                            </ul>
                            <p>Total Amount: <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span
                                class="ml-2" v-if="country == 'usa'">&#36;</span>{{ total_amount.toLocaleString() }}</p>
                            <p>Total Amount Due: <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span
                                class="ml-2" v-if="country == 'usa'">&#36;</span>{{ total_amount > balance ?
                                  Math.round(total_amount - balance, 2).toLocaleString() : Math.round(balance - total_amount,
                                    2).toLocaleString() }}
                              <span class="custom-tooltip-container" style="text-decoration: underline;cursor:pointer;">
                                <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                                  <path fill="currentColor"
                                    d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" />
                                </svg>
                                <span class="custom-tooltiptext" style="left:-60px">If there are available funds in your
                                  credit balance, its total sum will be deducted from your total billing amount.</span>
                              </span>
                            </p>
                            <p>Total Users: {{ total_users }}</p>
                            <p class="mt-2">
                              <template v-if="country == 'usa'">
                                <span class="btn" @click="stripePay" v-if="payment_term === 'payment'">
                                  Make Payment
                                </span>
                              </template>
                              <template v-else>
                                <span class="btn" @click="makePayment" v-if="payment_term === 'payment'">
                                  Make Payment
                                </span>
                              </template>
                              <span class="btn" @click="renewPayment" v-if="payment_term === 'renew'">
                                Renew
                              </span>
                            </p>
                            <p class="mt-2">
                              <img src="@/assets/visa.png" />
                              <img class="ml-2" src="@/assets/mastercard.png" />
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-2">
                    <h5 class="my-3">Billing</h5>
                    <div class="card w-100">
                      <div class="card-body">
                        <p>Credit Balance: <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                            v-if="country == 'usa'">&#36;</span>{{ Number(balance).toLocaleString() }}</p>
                        <p>Current Total Users: {{ company_total_users }} </p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>
            <template v-if="completed">
              <div class="card shadow-sm p-3 mb-5 bg-white rounded listed-department col-md-4">
                <div class="card-body">
                  <h4>
                    <strong style="color:#0f4670">{{ current_plan }}</strong>
                  </h4>
                  <p class="my-3">
                    <strong>Status: </strong> Active
                  </p>
                  <p>
                    No outstanding billing
                  </p>
                  <hr />
                  <p>Credit Balance: <span class="ml-2" v-if="country == 'nigeria'">&#8358;</span><span class="ml-2"
                      v-if="country == 'usa'">&#36;</span>{{ Number(balance).toLocaleString() }}</p>
                  <p>Current User: {{ company_total_users }}</p>
                </div>
              </div>
            </template>
          </template>
        </template>
      </template>
    </div>
    <loading ref="loading"></loading>
    <notify ref="notify"></notify>
    <logout ref="logout"></logout>
    <payment-analysis ref="analysis"></payment-analysis>
    <invite ref="invite"></invite>
  </div>
</template>
<style scoped>
#app {
  height: auto !important;
}

.setup-account {
  height: auto;
}

.remove-height {
  height: 100%;
}

.single-title {
  font-size: 16px;
  font-weight: bold;
  margin-top: 1.5em;
}

.single-title:first-child {
  margin-top: 0px !important;
}

h6 {
  font-family: "Poppins", "sans-serif";
}

.custom-tooltip-container {
  position: relative;
  display: inline-block;
}

.custom-tooltip-container:hover .custom-tooltiptext {
  visibility: visible;
  opacity: 1;
  padding: 5px 10px;
}

.custom-tooltiptext {
  visibility: hidden;
  background-color: #596a73;
  color: #fff;
  text-align: center;
  border-radius: 3px;
  padding: 2px 5px;
  position: absolute;
  z-index: 1;
  top: 25px;
  opacity: 0;
  -webkit-transition: opacity 0.5s, padding 0.3s;
  transition: opacity 0.5s, padding 0.3s;
  font-size: 12px;
  display: inline-block;
  width: 145px;
}

.form .package {
  width: 100%;
}

.small-text {
  font-size: 14px;
  margin-left: 0.3em;
}

span.create_public {
  display: block;
  margin-top: 0.5em;
}

span.create_public label input {
  display: inline !important;
  /*width: auto !important;*/
}

.add-department .error {
  color: #fc6d6c;
}

.form {
  background: rgb(245, 247, 250);
  height: 100%;
  text-align: left;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 1em;
}

.form .add-department {
  width: 30%;
}

.form .add-department h4 {
  font-weight: bold;
}

.form .btn {
  cursor: pointer;
  background: #0f4670;
  color: #fff;
  border-radius: 3px;
  padding: 1em 1em;
  display: inline-block;
  text-align: center;
  border: none;
  width: 100%;
}

.form .btn-cancel {
  cursor: pointer;
  background: transparent;
  color: #444;
  border: 1px solid #444;
  border-radius: 3px;
  padding: 1em 1em;
  display: inline-block;
  text-align: center;
  width: 100%;
}

.top-header {
  border-bottom: 1px solid #f9f9f9;
}

.undraw {
  width: 20%;
}

.undraw img {
  max-width: 100%;
}

.bottom-pane {
  text-align: left;
}

.listed-department {
  background: #fff;
  padding: 1em;
  width: 60%;
  height: auto;
}

.listed-department li {
  display: flex;
  align-items: center;
  margin-bottom: 0.9em;
}

.listed-department li span {
  margin-left: 0.4em;
}

.bottom-pane h1 {
  font-size: 50px;
  font-weight: bold;
  color: #000;
}

p {
  margin: 0;
}

.add-department p:first-child {
  margin-bottom: 0.6em !important;
}

.bottom-pane {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding-top: 0.9em;
}

.listed-department ul li .department-mode {
  display: flex !important;
  justify-content: space-between !important;
  width: 100%;
}

.listed-department ul li .department-mode .text-field {
  flex-grow: 2;
}

.action span {
  cursor: pointer;
}

input[name="create_folder"] {
  width: auto;
}
</style>

<script>
import loading from "@/components/Loading";
import top from "@/components/Top";
import logout from "@/components/Logout";
import notify from "@/components/Notify";
import { mapMutations } from "vuex";
import cookies from "@/services/cookies";
import axios from "axios";
import config from "@/services/config";
import moment from "moment";
import paymentAnalysis from "@/components/Payment-Analysis";
import { snakeCase, inRange, capitalize } from "lodash";
import TopHeader from "@/components/Top-Header";
import Invite from '@/components/Invite';

export default {
  components: {
    TopHeader,
    loading,
    notify,
    paymentAnalysis,
    Invite,
    logout,
  },
  data() {
    return {
      answer: "",
      error: false,
      department: "",
      departments: [],
      name: "",
      post: true,
      department_name_exist: false,
      create_folder: false,
      firstname: localStorage.getItem("firstname"),
      lastname: localStorage.getItem("lastname"),
      position: localStorage.getItem("position"),
      account_type: "",
      current_plan: "",
      charge_plan: "", // Plan use in calculating what to charge the user during payment
      total_users: 0,
      company_total_users: 0,
      price: 0,
      total_price: 0,
      amount_paid: 0,
      balance: 0,
      tran_ref: "",
      email: "",
      monthly: "",
      yearly: "",
      country: "",
      plan: "monthly",
      currency: "",
      completed: false,
      is_subscription_active: false,
      expiration_date: "",
      user_plan: "",
      packages: [],
      expired_trial: [],
      trial_still_on: [],
      total_amount: "",
      pricing: "",
      company_price: "",
      unit_prices: "",
      min_total_users: "",
      max_total_users: "",
      durationType: "monthly",
      selected: "business",
      add_more_users: false,
      sub_days_left: 0,
      chosen_plan: "",
      plan_tag: 0,
      payment_term: "payment",
      payment_state: '',
      url:
        process.env.NODE_ENV === "development"
          ? process.env.VUE_APP_HTTP +
          "://" +
          config.origin +
          ":" +
          process.env.VUE_APP_PORT +
          "/update-payment"
          : "https://" + process.env.VUE_APP_URL + "/update-payment",
      redirect: process.env.VUE_APP_REDIRECT + "/payments-billing",
    };
  },
  methods: {
    ...mapMutations([
      "SET_FILE_ACTION",
      "REMOVE_FILE_ACTION",
      "SET_DIRECTORY_CHILDREN",
      "TOGGLE_FILE_INFO",
      "SORT_DIRECTORY_CHILDREN",
      "SORT_STORED_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "GET_DIRECTORY_CHILDREN",
      "CLOSE_FILE_INFO",
      "SET_PATH",
      "UPDATE_SLIDEIN",
      "UPDATE_SLIDEOUT",
      "UPDATE_BODY_MENU",
      "UPDATE_MENU",
      "UPDATE_TOTAL_CREATED_IMAGES",
      "UPDATE_TOTAL_CREATED_DOCUMENTS",
      "UPDATE_TOTAL_CREATED_FOLDERS",
      "SET_FIRSTNAME",
      "SET_LASTNAME",
      "SET_EMAIL",
      "SET_PHONE",
      "SET_POSITION",
      "SET_DEPARTMENT",
      "SET_COUNTRY",
      "SET_DATE_CREATED",
      "SET_ACCT_TYPE",
      "SET_ISADMIN",
      "SET_PHOTO",
      "UPDATE_TOTAL_SPACE",
      "UPDATE_DEFAULT_FOLDER",
      "UPDATE_TOTAL_USED_SPACE",
      "SET_ISTRIAL",
      "SET_ISSTAFF",
      "SET_ISSUPERADMIN",
      "SET_PATH",
      "SORT_DIRECTORY_CHILDREN",
      "SET_CURRENT_DIRECTORY",
      "SET_CURRENT_PLAN",
      "UPDATE_PUBLIC_FOLDER_ID",
      "HIDE_FILE_INFO",
      "SET_FILE_ACTION",
      "SET_SELECT_ALL",
      "SET_USER_PLAN",
      "UPDATE_USER",
      "SET_NAME",
      "SET_IS_SECURITY_QUESTION",
      "SET_REFERRAL_LINK",
      "SET_HAS_CRM",
      "SET_HAS_INVEX",
      "SET_INVEX_DOMAIN",
      "SET_INVEX_API_URL"
    ]),
    invite() {
      this.$refs.invite.load();
    },
    viewmore(index) {
      this.packages[index].view = !this.packages[index].view;
    },
    checkTerm() {
      if (this.total_amount > this.balance) {
        // ? Math.round(total_amount - balance, 2).toLocaleString() : Math.round(balance - total_amount, 2).toLocaleString()
        this.payment_term = "payment";
      } else {
        this.payment_term = "renew";
      }
    },
    showmodal() {
      this.$refs.analysis.load();
    },
    expiration() {
      return moment(this.expiration_date).format("dddd, MMMM D, YYYY");
    },
    more_users() {
      this.add_more_users = !this.add_more_users;
      this.completed = false;
    },
    snakeCase(name) {
      return snakeCase(name);
    },
    capitalize(name) {
      return capitalize(name);
    },
    reversePlanName(name) {
      let that = this;
      let str = name.split("_");
      let nameStr = str.map((st) => {
        return that.capitalize(st);
      });

      return nameStr.join(" ");
    },
    selectPlan(plan, tag) {
      // this.current_plan = ''
    },
    select_plan(name) {
      this.selected = name;
      this.charge_plan = name;
      this.chosen_plan = this.reversePlanName(name);
      if (this.charge_plan == 'personal_pro') {
        this.plan_tag = 2
      } else if (this.charge_plan == 'business') {
        this.plan_tag = 3
      } else {
        this.plan_tag = 4
      }
      this.max_total_users = name === "business" ? 20 : 1000;
      if (this.charge_plan === "business") {
        if (this.total_users >= 2) {
          if (this.total_users > 20) {
            if (this.charge_plan === "business" && this.total_users > 20) {
              this.company_price = this.unit_prices[name][this.country];
              this.total_users = 20;
              this.discount_pricing(this.durationType);
              this.$refs.notify.load(
                "You can only add max of 20 users in your current plan. Upgrade to <strong>Business Plus</strong> to add more users."
              );
            }
          }
          this.min_total_users = 2;
          this.total_users =
            this.company_total_users < 2 ? 2 : this.company_total_users;
        } else {
          this.min_total_users = 2;
          this.total_users = 2;
        }
      }

      if (this.charge_plan === "personal_pro") {
        this.total_users = 1;
      }

      if (this.charge_plan === "business_plus") {
        if (this.total_users >= 3) {
          this.min_total_users = 3;
          this.total_users =
            this.company_total_users < 3 ? 3 : this.company_total_users;
        } else {
          this.min_total_users = 3;
          this.total_users = 3;
        }
      }
      this.company_price = this.unit_prices[name][this.country];
      this.discount_pricing(this.durationType);
      this.checkTerm();
    },
    getBalance() {
      if (this.account_type === 1) {
        if (
          this.charge_plan === "business_plus" ||
          this.charge_plan === "business"
        ) {
          if (this.durationType === "monthly") {
            let currentTotalUsersCost = this.monthly * this.company_total_users;
            let totalSelectedUsersCost = this.monthly * this.total_users;
            return currentTotalUsersCost > totalSelectedUsersCost
              ? Math.round(currentTotalUsersCost - totalSelectedUsersCost, 2)
              : Math.round(totalSelectedUsersCost - currentTotalUsersCost, 2);
          } else {
            let currentTotalUsersCost =
              this.yearly * 12 * this.company_total_users;
            let totalSelectedUsersCost = this.yearly * 12 * this.total_users;
            return currentTotalUsersCost > totalSelectedUsersCost
              ? Math.round(currentTotalUsersCost - totalSelectedUsersCost, 2)
              : Math.round(totalSelectedUsersCost - currentTotalUsersCost, 2);
          }
        } else {
          return 0;
        }
      } else {
        if (this.$store.ISTRIAL) {
          return Math.round(this.total_amount, 2);
        } else {
          if (this.is_subscription_active) {
            if (this.durationType === "monthly") {
              let totalSelectedUsersCost =
                ((this.monthly * this.total_users) / 30) * this.sub_days_left;
              return Math.round(totalSelectedUsersCost, 2);
            } else {
              let totalSelectedUsersCost =
                ((this.yearly * 12 * this.total_users) / 360) *
                this.sub_days_left;
              return Math.round(totalSelectedUsersCost, 2);
            }
          } else {
            if (this.durationType === "monthly") {
              let currentTotalUsersCost =
                this.monthly * this.company_total_users;
              let totalSelectedUsersCost = this.monthly * this.total_users;
              return currentTotalUsersCost > totalSelectedUsersCost
                ? Math.round(currentTotalUsersCost - totalSelectedUsersCost, 2)
                : Math.round(totalSelectedUsersCost - currentTotalUsersCost, 2);
            } else {
              let currentTotalUsersCost =
                this.yearly * 12 * this.company_total_users;
              let totalSelectedUsersCost = this.yearly * 12 * this.total_users;
              return currentTotalUsersCost > totalSelectedUsersCost
                ? Math.round(currentTotalUsersCost - totalSelectedUsersCost, 2)
                : Math.round(totalSelectedUsersCost - currentTotalUsersCost, 2);
            }
          }
        }
      }
    },
    calculateTotal(totalAmount) {
      if (this.account_type === 1) {
        this.total_amount = totalAmount;
      } else {
        if (this.$store.getters.ISTRIAL) {
          this.total_amount = totalAmount;
        } else {
          if (this.is_subscription_active) {
            if (this.plan === "monthly") {
              let perDayCost = totalAmount / 30;
              let cost = perDayCost * this.sub_days_left;
              this.total_amount = Math.round(cost, 2);
            } else {
              let perDayCost = totalAmount / 360;
              let cost = perDayCost * this.sub_days_left;
              this.total_amount = Math.round(cost, 2);
            } // / this.sub_days_left
          } else {
            this.total_amount = totalAmount;
          }
        }
      }
    },
    discount_pricing(durationType) {
      if (this.charge_plan === "business" && this.total_users > 20) {
        return;
      }

      let totalAmount = 0;

      if (this.charge_plan === "personal_pro") {
        if (durationType === "yearly") {
          this.yearly = this.company_price["year"];
          this.monthly = this.company_price["month"];
          this.total_amount =
            this.company_price["year"] * 12 * Number(this.total_users);
        } else {
          this.yearly = this.company_price["year"];
          this.monthly = this.company_price["month"];
          this.total_amount =
            this.company_price["month"] * Number(this.total_users);
        }
      }

      if (this.charge_plan === "business") {
        if (durationType === "yearly") {
          if (
            inRange(this.total_users, 1, 7) ||
            inRange(this.total_users, 1, 8)
          ) {
            this.yearly = this.company_price["two"]["year"];
            this.monthly = this.company_price["two"]["month"];
            totalAmount =
              this.company_price["two"]["year"] * 12 * Number(this.total_users);
            this.calculateTotal(totalAmount);
            // console.log(this.total_amount)
          }

          if (
            inRange(this.total_users, 8, 13) ||
            inRange(this.total_users, 8, 14)
          ) {
            this.yearly = this.company_price["eight"]["year"];
            this.monthly = this.company_price["eight"]["month"];
            totalAmount =
              this.company_price["eight"]["year"] *
              12 *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
          }

          if (
            inRange(this.total_users, 14, 20) ||
            inRange(this.total_users, 15, 21)
          ) {
            this.yearly = this.company_price["fourteen"]["year"];
            this.monthly = this.company_price["fourteen"]["month"];
            totalAmount =
              this.company_price["fourteen"]["year"] *
              12 *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
        } else {
          if (
            inRange(this.total_users, 1, 7) ||
            inRange(this.total_users, 1, 8)
          ) {
            this.monthly = this.company_price["two"]["month"];
            this.yearly = this.company_price["two"]["year"];
            totalAmount =
              this.company_price["two"]["month"] * Number(this.total_users);
            this.calculateTotal(totalAmount);
            // console.log(this.total_amount)
          }

          if (
            inRange(this.total_users, 8, 13) ||
            inRange(this.total_users, 8, 14)
          ) {
            this.monthly = this.company_price["eight"]["month"];
            this.yearly = this.company_price["eight"]["year"];
            totalAmount =
              this.company_price["eight"]["month"] * Number(this.total_users);
            this.calculateTotal(totalAmount);
            // console.log(this.total_amount)
          }

          if (
            inRange(this.total_users, 14, 20) ||
            inRange(this.total_users, 15, 21)
          ) {
            this.monthly = this.company_price["fourteen"]["month"];
            this.yearly = this.company_price["fourteen"]["year"];
            totalAmount =
              this.company_price["fourteen"]["month"] *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
            // console.log(this.total_amount)
          }
        }
      }

      if (this.charge_plan === "business_plus") {
        if (durationType === "yearly") {
          if (
            inRange(this.total_users, 1, 21) ||
            inRange(this.total_users, 1, 22)
          ) {
            this.yearly = this.company_price["two"]["year"];
            this.monthly = this.company_price["two"]["month"];
            totalAmount =
              this.company_price["two"]["year"] * 12 * Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
          if (
            inRange(this.total_users, 22, 50) ||
            inRange(this.total_users, 22, 51)
          ) {
            this.yearly = this.company_price["thirty_two"]["year"];
            this.monthly = this.company_price["thirty_two"]["month"];
            totalAmount =
              this.company_price["thirty_two"]["year"] *
              12 *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
          if (
            inRange(this.total_users, 51, 150) ||
            inRange(this.total_users, 51, 151)
          ) {
            this.yearly = this.company_price["fifty_one"]["year"];
            this.monthly = this.company_price["fifty_one"]["month"];
            totalAmount =
              this.company_price["fifty_one"]["year"] *
              12 *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
          if (
            inRange(this.total_users, 151, 250) ||
            inRange(this.total_users, 151, 251)
          ) {
            this.yearly =
              this.company_price["one_hundred_and_fifty_one"]["year"];
            this.monthly =
              this.company_price["one_hundred_and_fifty_one"]["month"];
            totalAmount =
              this.company_price["one_hundred_and_fifty_one"]["year"] *
              12 *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
          if (
            inRange(this.total_users, 251, 350) ||
            inRange(this.total_users, 251, 351)
          ) {
            this.yearly =
              this.company_price["two_hundred_and_fifty_one"]["year"];
            this.monthly =
              this.company_price["two_hundred_and_fifty_one"]["month"];
            totalAmount =
              this.company_price["twe_hundred_and_fifty_one"]["year"] *
              12 *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
          if (
            inRange(this.total_users, 351, 550) ||
            inRange(this.total_users, 351, 551)
          ) {
            this.yearly =
              this.company_price["three_hundred_and_fifty_one"]["year"];
            this.monthly =
              this.company_price["three_hundred_and_fifty_one"]["month"];
            totalAmount =
              this.company_price["three_hundred_and_fifty_one"]["year"] *
              12 *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
          if (
            inRange(this.total_users, 551, 750) ||
            inRange(this.total_users, 551, 751)
          ) {
            this.yearly =
              this.company_price["five_hundred_and_fifty_one"]["year"];
            this.monthly =
              this.company_price["five_hundred_and_fifty_one"]["month"];
            totalAmount =
              this.company_price["five_hundred_and_fifty_one"]["year"] *
              12 *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
          if (
            inRange(this.total_users, 751, 1000) ||
            inRange(this.total_users, 751, 1001)
          ) {
            this.yearly =
              this.company_price["seven_hundred_and_fifty_one"]["year"];
            this.monthly =
              this.company_price["seven_hundred_and_fifty_one"]["month"];
            totalAmount =
              this.company_price["seven_hundred_and_fifty_one"]["year"] *
              12 *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
        } else {
          if (
            inRange(this.total_users, 1, 21) ||
            inRange(this.total_users, 1, 22)
          ) {
            this.monthly = this.company_price["two"]["month"];
            this.yearly = this.company_price["two"]["year"];
            totalAmount =
              this.company_price["two"]["month"] * Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
          if (
            inRange(this.total_users, 22, 50) ||
            inRange(this.total_users, 22, 51)
          ) {
            this.monthly = this.company_price["thirty_two"]["month"];
            this.yearly = this.company_price["thirty_two"]["year"];
            totalAmount =
              this.company_price["thirty_two"]["month"] *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
          if (
            inRange(this.total_users, 51, 150) ||
            inRange(this.total_users, 51, 151)
          ) {
            this.monthly = this.company_price["fifty_one"]["month"];
            this.yearly = this.company_price["fifty_one"]["year"];
            totalAmount =
              this.company_price["fifty_one"]["month"] *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
          if (
            inRange(this.total_users, 151, 250) ||
            inRange(this.total_users, 151, 251)
          ) {
            this.monthly =
              this.company_price["one_hundred_and_fifty_one"]["month"];
            this.yearly =
              this.company_price["one_hundred_and_fifty_one"]["year"];
            totalAmount =
              this.company_price["one_hundred_and_fifty_one"]["month"] *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
          if (
            inRange(this.total_users, 251, 350) ||
            inRange(this.total_users, 251, 351)
          ) {
            this.monthly =
              this.company_price["two_hundred_and_fifty_one"]["month"];
            this.yearly =
              this.company_price["two_hundred_and_fifty_one"]["year"];
            totalAmount =
              this.company_price["twe_hundred_and_fifty_one"]["month"] *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
          if (
            inRange(this.total_users, 351, 550) ||
            inRange(this.total_users, 351, 551)
          ) {
            this.monthly =
              this.company_price["three_hundred_and_fifty_one"]["month"];
            this.yearly =
              this.company_price["three_hundred_and_fifty_one"]["year"];
            totalAmount =
              this.company_price["three_hundred_and_fifty_one"]["month"] *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
          if (
            inRange(this.total_users, 551, 750) ||
            inRange(this.total_users, 551, 751)
          ) {
            this.monthly =
              this.company_price["five_hundred_and_fifty_one"]["month"];
            this.yearly =
              this.company_price["five_hundred_and_fifty_one"]["year"];
            totalAmount =
              this.company_price["five_hundred_and_fifty_one"]["month"] *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
          if (
            inRange(this.total_users, 751, 1000) ||
            inRange(this.total_users, 751, 1001)
          ) {
            this.monthly =
              this.company_price["seven_hundred_and_fifty_one"]["month"];
            this.yearly =
              this.company_price["seven_hundred_and_fifty_one"]["year"];
            totalAmount =
              this.company_price["seven_hundred_and_fifty_one"]["month"] *
              Number(this.total_users);
            this.calculateTotal(totalAmount);
          }
        }
      }

      this.checkTerm();
      // console.log(this.getBalance())
    },
    user_choosen(evt) {
      if (this.charge_plan === "business" && this.total_users > 20) {
        this.total_users = 20;
        this.discount_pricing(this.durationType);
        this.$refs.notify.load(
          "You can only add max of 20 users in your current plan. Upgrade to <strong>Business Plus</strong> to add more users."
        );
        return;
      }
      if (this.charge_plan === "personal_pro") {
        if (this.durationType === "yearly") {
          this.total_amount = this.pricing.price_yearly * this.total_users * 12;
        }

        if (this.durationType === "monthly") {
          this.total_amount = this.pricing.price_monthly * this.total_users;
        }
      } else {
        if (evt.target.value == "" || evt.target.value == 0) {
          if (this.$store.getters.ISTRIAL) {
            this.total_users = this.min_total_users;
          } else {
            if (this.is_subscription_active) {
              this.total_users = 1;
            } else {
              this.total_users = this.min_total_users;
            }
          }
        }
        this.discount_pricing(this.durationType);
      }

      this.checkTerm();
    },
    amt_choosen(evt) {
      // if (this.current_plan === 'Business' && (this.total_users == 21 || this.total_users == 20)) {
      //   this.$refs.notify.load('You can only add max of 20 users in your current plan. Upgrade to <strong>Business Plus</strong> to add more users.')
      //   return
      // }

      this.durationType = evt.target.value;

      if (this.charge_plan === "personal_pro") {
        if (evt.target.value === "yearly") {
          this.total_amount = this.pricing.price_yearly * this.total_users * 12;
        }

        if (evt.target.value === "monthly") {
          this.total_amount = this.pricing.price_monthly * this.total_users;
        }
      } else {
        this.discount_pricing(evt.target.value);
      }

      this.checkTerm();
    },
    showPackName(name) {
      let n = name.split("_");
      if (n.length > 1) {
        return n.join(" ");
      } else {
        return n[0];
      }
    },
    daysLeft() {
      let cur = moment(moment.now());
      let foundtime = moment(this.expiration_date);
      let days = foundtime.diff(cur, "days");

      if (days < 1) {
        return 'Expired ' + (days * -1) + ' days ago'
      } else {
        return days + ' days left to expiration'
      }
    },
    showDaysLeft(createdAt) {
      let cur = moment(moment.now());
      let foundtime = moment(createdAt);
      let days = foundtime.diff(cur, "days");
      return days;
    },
    check(evt) {
      if (evt.target.value !== "") {
        this.error = false;
      }
    },
    close() {
      this.error.message = false;
    },
    logout() {
      this.$refs.logout.logout();
    },
    getTotalAmount() {
      if (this.$store.getters.ISTRIAL) {
        return this.total_amount;
      } else {
        if (this.is_subscription_active) {
          return this.total_amount;
        } else {
          return this.total_amount > this.balance
            ? this.total_amount - this.balance
            : this.balance - this.total_amount;
        }
      }
    },
    getPaymentLink() {
      if (this.$store.getters.ISTRIAL) {
        this.payment_state = 'update'
        return process.env.NODE_ENV === "development"
          ? process.env.VUE_APP_HTTP +
          "://" +
          config.origin +
          ":" +
          process.env.VUE_APP_PORT +
          "/update-payment"
          : "https://" + process.env.VUE_APP_URL + "/update-payment";
      } else {
        if (this.account_type === 1) {
          this.payment_state = 'make'
          return process.env.NODE_ENV === "development"
            ? process.env.VUE_APP_HTTP +
            "://" +
            config.origin +
            ":" +
            process.env.VUE_APP_PORT +
            "/make-payment"
            : "https://" + process.env.VUE_APP_URL + "/make-payment";
        } else {
          if (this.is_subscription_active) {
            this.payment_state = 'process'
            return process.env.NODE_ENV === "development"
              ? process.env.VUE_APP_HTTP +
              "://" +
              config.origin +
              ":" +
              process.env.VUE_APP_PORT +
              "/process-payment"
              : "https://" + process.env.VUE_APP_URL + "/process-payment";
          } else {
            this.payment_state = 'make'
            return process.env.NODE_ENV === "development"
              ? process.env.VUE_APP_HTTP +
              "://" +
              config.origin +
              ":" +
              process.env.VUE_APP_PORT +
              "/make-payment"
              : "https://" + process.env.VUE_APP_URL + "/make-payment";
          }
        }
      }
    },
    async stripePay() {
      this.$refs.loading.load();
      let that = this
      let totalAmount = this.getTotalAmount();

      let plan = "";
      let durationType = "";
      let plan_tag = ""
      if (that.user_plan === 1) {
        plan = that.chosen_plan;
        durationType = that.durationType;
      } else {
        if (that.user_plan === 2) {
          plan = that.chosen_plan;
          durationType = that.durationType;
        } else {
          plan = that.chosen_plan;
          durationType = that.durationType;
        }
      }

      let data = {
        token: cookies.getCookie("token"),
        duration_type: durationType,
        plan: plan,
        qty: Number(that.account_type) === 1 ? 1 : that.total_users,
        currency: that.currency,
        amount: totalAmount,
        tran_ref: that.tran_ref,
        balance: that.getBalance(),
        recurring: true,
        plan_tag: that.plan_tag,
        payment_state: this.payment_state,
        cancel_url: 'payments-billing',
        success_url: 'payments-billing'
      };
      let rst = await axios.post(process.env.VUE_APP_GET_STRIPE_PAYMENT_URL, data);
      if (rst.data.data == true) {
        window.location.replace(rst.data.url);
      } else {
        that.$router.push("/login?redirect=" + that.redirect);
      }
    },
    makePayment() {
      let that = this;
      let totalAmount = this.getTotalAmount();

      FlutterwaveCheckout({
        public_key:
          process.env.VUE_APP_NODE_ENV === "development"
            ? "FLWPUBK_TEST-ebc0edc829e477e44a0b55262fb8f688-X"
            : "FLWPUBK-d50d314482e0829339383de4f2f2cfc9-X",
        tx_ref: that.tran_ref,
        amount:
          process.env.VUE_APP_NODE_ENV === "development" ? 3000 : totalAmount,
        currency: that.currency,
        customer: {
          email: that.email,
          phone_number: "",
          name: that.name,
        },
        callback: function (data) {
          if (data.status === "successful" || data.status == 'completed') {
            let plan = "";
            let durationType = "";
            if (that.user_plan === 1) {
              plan = that.chosen_plan;
              durationType = that.durationType;
            } else {
              if (that.user_plan === 2) {
                plan = that.chosen_plan;
                durationType = that.durationType;
              } else {
                plan = that.chosen_plan;
                durationType = that.durationType;
              }
            }

            that.$refs.loading.load();
            let postData = {
              token: cookies.getCookie("token"),
              duration_type: durationType,
              plan: plan,
              flw_ref: data.flw_ref,
              qty: Number(that.account_type) === 1 ? 1 : that.total_users,
              currency_type: that.currency,
              amount: totalAmount,
              tran_ref: that.tran_ref,
              balance: that.getBalance(),
              recurring: true,
            };

            let url = that.getPaymentLink();

            axios
              .post(url, postData)
              .then((res) => {
                if (res.data.data === true) {
                  if (that.is_subscription_active) {
                    that.balance = that.balance + totalAmount;
                    that.total_users = 1;
                  } else {
                    that.balance = that.getBalance();
                  }
                  that.current_plan = plan;
                  that.completed = true;
                  that.$refs.loading.close();
                  that.$refs.notify.load("Payment was successful.");
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            that.$refs.notify.load(
              "Payment was not successful. Please try again."
            );
          }
        },
        onclose: function () {
          // close modal
        },
      });
    },
    renewPayment() {
      let that = this;

      let url =
        process.env.NODE_ENV === "development"
          ? process.env.VUE_APP_HTTP +
          "://" +
          config.origin +
          ":" +
          process.env.VUE_APP_PORT +
          "/renew-payment"
          : "https://" + process.env.VUE_APP_URL + "/renew-payment";
      let plan = "";
      let durationType = "";
      let totalAmount = this.total_amount;
      if (that.user_plan === 1) {
        plan = "Personal Pro";
        durationType = that.durationType;
      } else {
        if (that.user_plan === 2) {
          plan = "Personal Pro";
          durationType = that.durationType;
        } else {
          plan = that.reversePlanName(that.charge_plan);
          durationType = that.durationType;
        }
      }

      this.$refs.loading.load();
      let postData = {
        token: cookies.getCookie("token"),
        plan: plan,
        duration_type: durationType,
        qty: Number(this.account_type) === 1 ? 1 : this.total_users,
        currency_type: that.currency,
        amount: totalAmount,
        tran_ref: that.tran_ref,
        recurring: true,
      };

      axios
        .post(url, postData)
        .then((res) => {
          if (res.data.data === true) {
            if (that.is_subscription_active) {
              that.balance = that.balance + totalAmount;
              that.total_users = 1;
            } else {
              that.balance = that.getTotalAmount();
            }
            that.current_plan = plan;
            that.completed = true;
            that.$refs.loading.close();
            that.$refs.notify.load("Payment was successful.");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    user_data() {
      let data = {
        token: cookies.getCookie("token"),
      };

      let that = this;

      this.$socket.emit("get-data", data, function (data) {
        if (data.data === true) {
          that.SET_ACCT_TYPE(data.account_type);
          that.SET_ISADMIN(data.isSuperAdmin);
          that.SET_FIRSTNAME(data.firstname);
          that.SET_LASTNAME(data.lastname);
          that.SET_NAME(data.firstname + " " + data.lastname);
          that.SET_EMAIL(data.email);
          that.SET_PHONE(data.phone);
          that.SET_POSITION(data.position);
          that.SET_DEPARTMENT(data.department);
          that.SET_COUNTRY(data.country ? data.country : "");
          that.SET_DATE_CREATED(data.date_created);
          that.SET_PHOTO(data.photo);
          that.UPDATE_TOTAL_SPACE(data.total_space);
          that.UPDATE_TOTAL_USED_SPACE(data.total_space_used);
          that.UPDATE_USER(data.id);
          that.SET_CURRENT_PLAN(data.current_plan);
          that.SET_USER_PLAN(data.user_plan);
          that.SET_HAS_CRM(data.hasCrm);
          that.SET_HAS_INVEX(data.hasInvex);
          that.SET_INVEX_DOMAIN(data.invex_domain);
          that.SET_INVEX_API_URL(data.invex_api_url);
          that.SET_ISTRIAL(data.isTrial);
          that.SET_ISSTAFF(data.isStaff);
          that.SET_ISSUPERADMIN(data.isSuperAdmin);
          that.SET_REFERRAL_LINK(data.referral_link);

          that.SET_IS_SECURITY_QUESTION(data.is_security_question);

          that.UPDATE_DEFAULT_FOLDER(data.default_folders);

          that.UPDATE_PUBLIC_FOLDER_ID(data.public_folder_id);

          localStorage.setItem("id", data.id);
          localStorage.setItem("email", data.email);
          localStorage.setItem(
            "is_security_question",
            data.is_security_question
          );
          sessionStorage.setItem("gi", data.group_folder_id);
          sessionStorage.setItem("pi", data.project_folder_id);

          that.UPDATE_TOTAL_CREATED_IMAGES(data.total_created_images);
          that.UPDATE_TOTAL_CREATED_DOCUMENTS(data.total_created_documents);
          that.UPDATE_TOTAL_CREATED_FOLDERS(data.total_created_folders);
        }
      });
    },
  },
  mounted() {
    let externalScript = document.createElement("script");
    // https://checkout.flutterwave.com/v3.js
    // https://js.paystack.co/v1/inline.js
    externalScript.setAttribute(
      "src",
      "https://checkout.flutterwave.com/v3.js"
    );
    document.head.appendChild(externalScript);

    this.$refs.loading.load();

    this.user_data();

    let that = this;
    let data = {
      load_plan: true,
      token: cookies.getCookie("token"),
    };

    this.$socket.emit("url:auth", data, (data) => {
      if (data.data === false) {
        that.$router.push("/login?redirect=" + that.redirect);
      } else {
        that.$refs.loading.close();
        that.name = data.name;
        that.tran_ref = data.tran_ref;
        that.email = data.email;
        if (data.currency === "") {
          that.currency = data.country === "nigeria" ? "NGN" : "USD";
          that.country = data.country;
        } else {
          that.currency = data.currency;
          that.country = data.currency === "NGN" ? "nigeria" : "usa";
        }
        that.current_plan =
          data.current_plan.name === "Free"
            ? "Personal Pro"
            : data.current_plan.name;
        that.charge_plan = snakeCase(
          data.current_plan.name === "Free"
            ? "Personal Pro"
            : data.current_plan.name
        );
        that.selected = snakeCase(
          data.current_plan.name === "Free"
            ? "Personal Pro"
            : data.current_plan.name
        );
        that.total_users = data.total_users;

        if (that.current_plan == 'Personal Pro') {
          that.plan_tag = 2
        } else if (that.current_plan == 'Free') {
          that.plan_tag = 1
        } else if (that.current_plan == 'Business') {
          that.plan_tag = 3
        } else {
          that.plan_tag = 4
        }

        that.payment_state = 'update'

        if (that.current_plan === "Business") {
          if (data.total_users > 1) {
            that.min_total_users = data.total_users;
            that.total_users = data.total_users;
          } else {
            that.min_total_users = 2;
            that.total_users = 2;
          }
        } else {
          if (data.total_users > 2) {
            that.min_total_users = data.total_users;
            that.total_users = data.total_users;
          } else {
            that.min_total_users = 3;
            that.total_users = 3;
          }
        }

        that.max_total_users =
          data.current_plan.name === "Business" ? 20 : 1000;
        that.account_type = data.account_type;
        that.total_price =
          data.account_type === 1 ? data.plan_price.price : 0;
        that.price = data.account_type === 1 ? data.plan_price.price : 0;
        that.is_subscription_active = data.is_subscription_active;
        that.pricing = data.plan_price;
        that.user_plan = data.user_plan;
        that.packages = data.package_plan;
        that.chosen_plan =
          data.current_plan.name === "Free"
            ? "Personal Pro"
            : data.current_plan.name;
        that.expiration_date = data.expiration_date;

        if (that.is_subscription_active) {
          that.company_total_users = data.total_users;
          that.total_users = 1;
          that.plan = data.billing_duration_type;
          that.durationType = data.billing_duration_type;
          that.company_price =
            data.unit_prices[snakeCase(data.current_plan.name)][that.country];
          that.amount_paid = data.amount_paid;
          that.balance = data.balance;
          that.sub_days_left = data.subDaysLeft;
          if (that.plan === "monthly") {
            that.total_amount =
              data.plan_price.price_monthly * data.total_users;
          } else {
            that.total_amount =
              data.plan_price.price_yearly * data.total_users;
          }

          that.discount_pricing(that.plan);
        } else {
          if (that.account_type === 1) {
            that.monthly = data.plan_price.price_monthly;
            that.yearly = data.plan_price.price_yearly;
            that.total_users = 1;
            that.balance = 0;
            that.unit_prices = data.unit_prices;
            that.total_amount =
              data.plan_price.price_monthly * data.total_users;
            that.company_total_users = 1;
          } else {
            that.company_total_users = data.total_users;
            that.total_amount =
              data.plan_price.price_monthly * data.total_users;
            that.unit_prices = data.unit_prices;
            that.balance = data.balance;
            that.company_price =
              data.unit_prices[snakeCase(data.current_plan.name)][
              that.country
              ];
            that.discount_pricing("yearly");
            that.discount_pricing("monthly");
          }
        }
      }
    });
  },
};
</script>
